import { OwnerLogo } from "../OwnerLogo/web";
import "./styles.less";
import { Owner } from "shared-components";

export const OwnerInfo = ({ owner = null }: { owner?: Owner }) => {
	if (owner == null) return null;

	return (
		<div className="owner-info">
			<OwnerLogo type="full" owner={owner} />
		</div>
	);
};
